import { useAuthState } from "./useAuthState";
import { useAuthRedirect } from "./useAuthRedirect";
import { useSignOut } from "./useSignOut";

export function useAuth() {
  const { authState, retry, refetchProfile, loadingStep, loadingProgress } = useAuthState();
  const { redirectBasedOnAuthState } = useAuthRedirect();
  const { signOut } = useSignOut();

  const redirectBasedOnAuthStateWrapper = () => {
    redirectBasedOnAuthState(authState);
  };

  return {
    ...authState,
    signOut,
    redirectBasedOnAuthState: redirectBasedOnAuthStateWrapper,
    retry,
    refetchProfile,
    loadingStep,
    loadingProgress
  };
}

export default useAuth;